import i18n from "./i18n";
import LanguageHelper from "./language-helper";
import { isDictionaryLoaded, markDictionaryLoaded } from "./cache";

function importDictionary(dictionary, lang) {
    return import(`../../lang/${lang}/${dictionary}.json`);
}

export default async function loadDictionary(dictionary, lang = LanguageHelper.get()) {
    i18n.locale = lang;
    i18n.defaultLocale = lang;

    if (isDictionaryLoaded(dictionary, lang)) return;

    try {
        const messages = await importDictionary(dictionary, lang);
        
        i18n.store({
            [lang]: {
                [dictionary]: messages.default
            }
        });

        markDictionaryLoaded(dictionary, lang);
    } catch (err) {
        console.error("Dictionary load failed:", dictionary, lang, err);
    }
}